import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import GreenArrow from '../../../../icons/green_arrow.svg';

// Styles
import styles from './ToggleArrow.styl';

const cx = classNames.bind(styles);

export default function ToggleArrow(props) {
  const { className, isOpen } = props;

  return (
    <div className={cx('ToggleArrow', className, { ToggleArrow_opened: isOpen })}>
      <GreenArrow width={14} height={20} />
    </div>
  );
}

ToggleArrow.defaultProps = {
  className: '',
  isOpen: false,
};

ToggleArrow.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
};
